export const ErrorTypes = {
    data() {
        return {
            ERROR_TYPE_NONE: 0,
            ERROR_TYPE_INFO: 1,
            ERROR_TYPE_WARNING: 2,
            ERROR_TYPE_ERROR: 3
        }
    }
}
